import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/DeleteOutlined';
import MenuIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import { Box, Button, Grid, IconButton, InputAdornment, Menu, MenuItem, ListItemIcon, ListItemText, TextField, Toolbar } from '@mui/material';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router';

import { ContextStore } from '../store/contextStore';
import { debounce } from '../utils';

export const ActivityCategoryListToolbar = (props) => {
    const history = useHistory();
    const searchQueryRef = React.useRef(null);
    const btSize = props.isSmallScreen ? 'medium' : 'small';
    const { hasPerm } = React.useContext(ContextStore);
    const [anchorEl, setAnchorEl] = React.useState(null);
    const menuOpen = Boolean(anchorEl);

    const handleSearchQueryChange = () => {
        debouncedSearchQueryChangeHandler.cancel();
        doSearch(searchQueryRef.current?.value);
    };

    const onCreateNewItemBtClick = () => {
        history.push('/activity-categories/create');
    };

    const debouncedSearchQueryChangeHandler = debounce(handleSearchQueryChange, 300);

    const doSearch = (query) => props.onQueryChange && props.onQueryChange(query);

    const handleMenuOpen = (ev) => {
        setAnchorEl(ev.currentTarget);
    };

    const handleMenuClose = () => {
        setAnchorEl(null);
    };

    const handleDeleteSelected = () => {
        handleMenuClose();
        props.onDeleteItem && props.onDeleteItem(props.selectedIds);
    };

    return (
        <Box sx={{ mt: { xs: 1, sm: 0 } }}>
            <Toolbar disableGutters={true}>
                <Box sx={{ width: '100%' }}>
                    <Grid container spacing={{ xs: 1, md: 2 }} sx={{ width: '100%' }}>
                        <Grid item xs={12} md={9}>
                            <Grid container spacing={{ xs: 1, md: 2 }} alignItems="center">
                                <Grid item xs={9} sm={10} md={4}>
                                    <TextField
                                        variant="filled"
                                        label="Search"
                                        size="small"
                                        onChange={debouncedSearchQueryChangeHandler}
                                        inputRef={searchQueryRef}
                                        fullWidth
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <IconButton aria-label="do search" onClick={handleSearchQueryChange} size={btSize}>
                                                        <SearchIcon />
                                                    </IconButton>
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </Grid>
                                {/* Same [+] as Activities on a phone (CP-5563). */}
                                <Grid item xs={3} sm={2} md="auto" sx={{ display: { xs: 'flex', md: 'none' }, justifyContent: 'flex-end' }}>
                                    {hasPerm('activity', 'write') && (
                                        <Button onClick={onCreateNewItemBtClick} variant="contained" color="primary">
                                            <AddIcon />
                                        </Button>
                                    )}
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid item xs={12} md={3} sx={{ mt: { xs: 0, md: 1 }, display: { xs: 'none', md: 'flex' }, justifyContent: 'flex-end', alignItems: 'flex-start' }}>
                            {props.selectedIds?.length > 0 && !props.isSmallScreen && (
                                <>
                                    <Button
                                        onClick={handleMenuOpen}
                                        variant="contained"
                                        color="primary"
                                        size={btSize}
                                        sx={{ whiteSpace: 'nowrap' }}
                                    >
                                        <MenuIcon />&nbsp;Actions
                                    </Button>
                                    <Menu
                                        anchorEl={anchorEl}
                                        open={menuOpen}
                                        onClose={handleMenuClose}
                                    >
                                        {/* CP-5545: disabled (grey), not hidden, without the delete permission. */}
                                        <MenuItem onClick={handleDeleteSelected} disabled={!hasPerm('activity', 'delete')}>
                                            <ListItemIcon><DeleteIcon color={hasPerm('activity', 'delete') ? 'error' : 'inherit'} /></ListItemIcon>
                                            <ListItemText>Delete selected ({props.selectedIds.length})</ListItemText>
                                        </MenuItem>
                                    </Menu>
                                </>
                            )}
                            {hasPerm('activity', 'write') && props.selectedIds?.length === 0 && (
                                <Button
                                    onClick={onCreateNewItemBtClick}
                                    variant="contained"
                                    color="primary"
                                    size={btSize}
                                    sx={{ whiteSpace: 'nowrap', mr: 1 }}
                                >
                                    <AddIcon />&nbsp;New activity category
                                </Button>
                            )}
                        </Grid>
                    </Grid>
                </Box>
            </Toolbar>
        </Box>
    );
};

export default ActivityCategoryListToolbar;

ActivityCategoryListToolbar.propTypes = {
    isSmallScreen: PropTypes.bool,
    onDeleteItem: PropTypes.func,
    selectedIds: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.string, PropTypes.number])),
    onQueryChange: PropTypes.func,
};

ActivityCategoryListToolbar.defaultProps = {
    isSmallScreen: false,
    selectedIds: [],
};
